import { SpaceType } from "../space";

export interface SubscriptionDetail {
  id: string;
  memberName: string;
  email: string;
  membershipName: string;
  locatable?: {
    id: string;
    name: string;
    shortAddress: string;
  };
  locatableType: string;
  membershipPlanName: string;
  startDate: string;
  status: string;
  cancelAt?: string;
  cancelReason?: string;
  orderConfirmation: string;
  orderId: string;
  endDate?: string;
  cancelledAt?: string;
  cancellationDate?: string;
  numberOfBookingUsed: number;
  numberOfBookingUnused: number;
  memberPhone: string;
  paymentStatus: "paid" | "payment_failed";
}

export interface MemberOfferingSpace {
  id: string;
  locationId: string;
  name: string;
  spaceType: SpaceType;
}

export function toMemberOfferingSpace(data: any): MemberOfferingSpace {
  return {
    id: data.id,
    locationId: data.location_id,
    name: data.name,
    spaceType: data.space_type,
  };
}

export function toSubscriptionDetail(data: any): SubscriptionDetail {
  return {
    id: data.id,
    memberName: data.member_name,
    email: data.email,
    membershipName: data.membership_name,
    locatable: data.locatable
      ? {
          id: data.locatable.id,
          name: data.locatable.name,
          shortAddress: data.locatable.short_address,
        }
      : undefined,
    locatableType: data.locatable_type,
    membershipPlanName: data.membership_plan_name,
    startDate: data.start_date,
    status: data.status,
    cancelAt: data.cancel_at,
    cancelReason: data.cancel_reason,
    orderConfirmation: data.order_confirmation,
    orderId: data.orderId,
    endDate: data.end_date,
    cancelledAt: data.cancelled_at,
    cancellationDate: data.cancellation_date,
    numberOfBookingUsed: data.number_of_booking_used,
    numberOfBookingUnused: data.number_of_booking_unused,
    memberPhone: data.member_phone,
    paymentStatus: data.payment_status,
  };
}

export interface SubscriptionBooking {
  id: string;
  status: string;
  startDate: string;
  endDate: string;
  localStartTime: string;
  localEndTime: string;
  memberId: string;
  subscriptionId: string;
  memberBookableType: string;
  memberBookable: MemberBookable;
  confirmationId: string;
}

export interface MemberBookable {
  id: string;
  location: {
    id: string;
    name: string;
    shortAddress: string;
  };
  space: {
    id: string;
    locationId: string;
    name: string;
    image?: {
      url: string;
      width: number;
      height: number;
    };
    spaceType: SpaceType;
  };
  cancellationAllowed: boolean;
  canceled: boolean;
}

export function toMemberBookable(data: any): MemberBookable {
  return {
    id: data.id,
    location: {
      id: data.location.id,
      name: data.location.name,
      shortAddress: data.location.short_address,
    },

    space: {
      id: data.space.id,
      locationId: data.space.location_id,
      name: data.space.name,
      image: data.space.image
        ? {
            url: data.space.image.url,
            width: data.space.image.width,
            height: data.space.image.height,
          }
        : undefined,
      spaceType: data.space.space_type,
    },

    cancellationAllowed: data.cancellation_allowed,
    canceled: data.canceled,
  };
}

export function toSubscriptionBooking(data: any): SubscriptionBooking {
  return {
    id: data.id,
    status: data.status,
    startDate: data.start_date,
    endDate: data.end_date,
    localStartTime: data.local_start_time,
    localEndTime: data.local_end_time,
    memberId: data.member_id,
    subscriptionId: data.subscription_id,
    memberBookableType: data.member_bookable_type,
    memberBookable: toMemberBookable(data.member_bookable),
    confirmationId: data.confirmation_id,
  };
}
